import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './auth/services/auth.service';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [RouterOutlet],
	template: '<router-outlet />'
})
export class AppComponent implements OnInit {
	private readonly authService = inject(AuthService);

	ngOnInit(): void {
		this.authService.getDomainUrl().subscribe();
	}
}
